<template>
  <div>
    <SnackbarComp :SnackbarComponent="SnackbarComponent" />

    <v-btn
      class="position-absolute text-none"
      style="top: 16px; left: 16px; z-index: 10"
      color="white"
      href="https://snappoll.mobil80.com"
      variant="tonal"
    >
      <div class="d-flex align-center">
        <v-icon>mdi-home</v-icon>
        <span class="font-weight-bold">Home</span>
      </div>
    </v-btn>

    <v-container
      fluid
      class="login-container d-flex align-center justify-center min-h-screen"
    >
      <div v-if="isLogin" class="login-card-wrapper">
        <!-- Decorative Elements -->
        <div class="decoration decoration-1"></div>
        <div class="decoration decoration-2"></div>

        <v-card width="420" class="custom-card login-card" elevation="20">
          <v-card-text>
            <!-- Logo -->
            <div class="text-center">
              <div class="logo-circle">
                <v-img width="50" src="/favicon.ico" alt="Snap Polls Logo">
                </v-img>
              </div>
              <h1 class="text-h4 text-semibold text-gradient-primary">
                SnapPoll
              </h1>
            </div>

            <v-divider class="my-1"></v-divider>

            <!-- Form -->
            <div>
              <!-- Email -->
              <div>
                <label class="text-sm text-semibold mb-2 d-block">
                  Email Address
                </label>
                <v-text-field
                  v-model="Login.email_id"
                  placeholder="user@example.com"
                  prepend-inner-icon="mdi-email-outline"
                  type="email"
                  variant="outlined"
                  density="compact"
                  :disabled="otpSent"
                  @keyup.enter="sendOTP"
                />
              </div>

              <!-- Send OTP Button -->
              <v-btn
                v-if="!otpSent"
                @click="sendOTP"
                block
                class="btn-primary-gradient mb-4"
                size="large"
                :loading="isLoading"
                :disabled="!Login.email_id || isLoading"
              >
                <v-icon start icon="mdi-email-send"></v-icon>
                Send OTP
              </v-btn>

              <!-- OTP Input (shown after OTP is sent) -->
              <div v-if="otpSent">
                <!-- <div class="bg-light-blue rounded-lg pa-2">
                  <p class="text-sm text-center mb-0 text-success">
                    <strong>OTP sent to {{ Login.email_id }}</strong>
                  </p>
                </div> -->

                <label class="text-sm text-semibold mb-2 d-block">
                  Enter 6-digit OTP Code
                </label>

                <!-- Vuetify OTP Input (6 digit fields) -->
                <div class="otp-input-container">
                  <v-text-field
                    v-for="(digit, index) in 6"
                    :key="index"
                    :ref="`otpInput${index}`"
                    v-model="otpDigits[index]"
                    type="text"
                    inputmode="numeric"
                    maxlength="1"
                    placeholder=""
                    variant="outlined"
                    density="compact"
                    class="otp-digit"
                    @input="handleOTPInput(index, $event)"
                    @keydown="handleOTPKeydown(index, $event)"
                    @keyup.enter="verifyOTP"
                  />
                </div>

                <!-- OTP Validity Timer -->

                <p
                  class="text-center text-sm font-weight-bold mb-4"
                  :style="{
                    color: counter < 30 ? '#f44336' : '#1976d2',
                  }"
                >
                  OTP expires in: {{ Math.floor(counter / 60) }}:{{
                    String(counter % 60).padStart(2, "0")
                  }}
                </p>

                <!-- Verify OTP Button -->
                <v-btn
                  @click="verifyOTP"
                  block
                  class="btn-primary-gradient"
                  size="large"
                  :loading="isLoading"
                  :disabled="otpDigits.join('').length !== 6 || isLoading"
                >
                  <v-icon start icon="mdi-login"></v-icon>
                  Verify & Sign In
                </v-btn>

                <!-- Change Email Button 
                <v-btn
                  @click="resetForm"
                  block
                  variant="text"
                  class="mt-2"
                  :disabled="isLoading"
                >
                  Use different email
                </v-btn> -->
              </div>
              <p class="text-caption py-2">
                Note:- Login enabled for invited curators only. If you wish to
                curate polls for your local community then
                <v-btn
                  size="x-small"
                  color="info"
                  variant="text"
                  @click="isLogin = false"
                  :ripple="false"
                  class="text-capitalize ma-0 pa-0"
                  >submit your interest</v-btn
                >
              </p>
            </div>
          </v-card-text>
        </v-card>
      </div>
      <div v-else>
        <v-card
          class="mx-auto pa-2 rounded-lg border"
          width="420"
          elevation="2"
        >
          <v-card-title
            class="d-flex align-center text-subtitle-1 font-weight-bold text-primary pb-2 pt-4"
          >
            <v-icon
              start
              icon="mdi-message-draw"
              size="small"
              class="mr-2"
            ></v-icon>
            Curator Request
            <v-spacer></v-spacer>
            <v-icon color="black" @click="isLogin = true"
              >mdi-close-thick</v-icon
            >
          </v-card-title>

          <v-divider class="mb-4"></v-divider>

          <v-card-text class="py-0">
            <v-form ref="feedbackForm" v-model="isFormValid">
              <v-text-field
                v-model="formData.user_name"
                label="Full Name *"
                variant="outlined"
                density="compact"
                prepend-inner-icon="mdi-account"
                :rules="[rules.required]"
                class="mb-2"
              ></v-text-field>

              <v-text-field
                v-model="formData.user_email_id"
                label="Email Address *"
                variant="outlined"
                density="compact"
                prepend-inner-icon="mdi-email"
                :rules="[rules.required, rules.email]"
                class="mb-2"
              ></v-text-field>

              <v-textarea
                v-model="formData.comments"
                label="Comments*"
                variant="outlined"
                density="compact"
                :rules="[rules.required]"
                prepend-inner-icon="mdi-comment-text"
                rows="4"
                auto-grow
                hide-details="auto"
              ></v-textarea>
            </v-form>
          </v-card-text>

          <v-card-actions
            class="px-4 pb-4 pt-4 mt-2 bg-grey-lighten-5 border-t rounded-b-lg"
          >
            <v-spacer></v-spacer>
            <v-btn variant="plain" size="small" @click="resetForm">
              Clear
            </v-btn>
            <v-btn
              color="primary"
              variant="flat"
              size="small"
              :disabled="!isFormValid"
              :loading="isLoading"
              @click="submitForm"
              class="px-4"
            >
              Submit Details
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-container>
  </div>
</template>

<script>
import {
  signIn,
  confirmSignIn,
  getCurrentUser,
  signOut,
} from "aws-amplify/auth";
import SnackbarComp from "@/components/Extras/SnackbarComp.vue";
import { useDisplay } from "vuetify";
import { GetCurrentUserInfo } from "@/mixins/Extras/GetCurrentUserInfo";
import { requestForCuratorAccess } from "@/graphql/mutations";
import { generateClient } from "aws-amplify/api";

const client = generateClient();

export default {
  name: "LoginPage",
  components: {
    SnackbarComp,
  },
  mixins: [GetCurrentUserInfo, requestForCuratorAccess],
  data() {
    return {
      CardHeight: 0,
      counter: 0,
      user: null,
      interval: null,
      OTPErrorMessage: "",
      testOTP: "",

      isLogin: true,
      isLoading: false,
      otpSent: false,

      SnackbarComponent: {},
      isFormValid: false,
      formData: {
        user_name: "",
        user_email_id: "",
        comments: "",
      },
      rules: {
        required: (value) => !!value || "This field is required.",
        email: (value) => {
          const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return pattern.test(value) || "Please enter a valid email address.";
        },
      },
      Login: {
        email_id: "",
        otp: "",
      },
      otpDigits: ["", "", "", "", "", ""],
    };
  },

  watch: {
    "Login.email_id"(val) {
      if (val && val !== null) {
        this.Login.email_id = val.toLowerCase();
      }
    },
  },

  created() {
    const display = useDisplay();
    this.CardHeight = display.height;
    this.$watch(
      () => display.height,
      (newHeight) => {
        this.CardHeight = newHeight;
      },
    );
  },

  mounted() {
    this.disableHistoryChanges();
  },

  methods: {
    async submitForm() {
      if (this.isFormValid) {
        try {
          this.isLoading = true;
          let result = await client.graphql({
            query: requestForCuratorAccess,
            authMode: "apiKey",
            variables: {
              input: {
                user_name: this.formData.user_name,
                user_email_id: this.formData.user_email_id,
                comments: this.formData.comments,
              },
            },
          });
          var ResultObj = JSON.parse(result.data.requestForCuratorAccess);
          if (ResultObj.status == 200 || ResultObj.status === "SUCCESS") {
            this.SnackbarComponent = {
              SnackbarVmodel: true,
              SnackbarColor: "success",
              SnackbarText: ResultObj.message || "Request raised successfully",
            };
            this.isLogin = true;
          }
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          this.SnackbarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "error",
            SnackbarText:
              error.errors[0].message || "An Error occurred. Try again",
          };
          console.log("Error", error);
        }
      } else {
        this.SnackbarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "error",
          SnackbarText: "Please fill all the required fields!",
        };
        return;
      }
    },

    disableHistoryChanges() {
      window.history.pushState({ ...history.state }, "", window.location.href);
      window.onpopstate = function () {
        window.history.pushState(
          { ...history.state },
          "",
          window.location.href,
        );
      };
    },

    sendOTP() {
      if (!this.Login.email_id) {
        this.SnackbarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "error",
          SnackbarText: "Please enter Email to Login",
        };
        return;
      }
      this.SignInMethod("SEND_OTP");
    },

    async SignInMethod(action) {
      switch (action) {
        case "SEND_OTP":
          try {
            this.isLoading = true;
            this.user = await signIn({
              username: this.Login.email_id,
              options: {
                authFlowType: "CUSTOM_WITHOUT_SRP",
              },
            });

            if (
              this.user.nextStep.signInStep ===
              "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE"
            ) {
              this.SnackbarComponent = {
                SnackbarVmodel: true,
                SnackbarColor: "primary",
                SnackbarText: `Verification OTP sent to ${this.Login.email_id}`,
              };
              this.counter = 120;
              this.isLoading = false;
              this.otpSent = true;
              this.$forceUpdate();
              this.startCounter();

              // Focus on first OTP input
              this.$nextTick(() => {
                this.$refs[`otpInput0`]?.[0]?.focus();
              });
            }
          } catch (error) {
            if (
              error.message ===
              "DefineAuthChallenge failed with error Error: NOT_AUTHORIZED : Kindly Sigup."
            ) {
              this.SignInMethod("SIGNUP");
            } else if (error.message === "There is already a signed in user.") {
              await signOut({ global: true });
              this.SignInMethod("SEND_OTP");
            } else {
              this.isLoading = false;
              this.SnackbarComponent = {
                SnackbarVmodel: true,
                SnackbarColor: "error",
                SnackbarText: error.message,
              };
            }

            console.log("Err", error);
          }
          break;

        case "VERIFY_OTP":
          try {
            this.isLoading = true;
            await confirmSignIn({ challengeResponse: this.Login.otp })
              .then(() => {
                this.SnackbarComponent = {
                  SnackbarVmodel: true,
                  SnackbarColor: "primary",
                  SnackbarText: "Login successful",
                };
                this.isLoading = false;
                this.ActivateMethod();
              })
              .catch((err) => {
                if (
                  err.message ===
                    "VerifyAuthChallengeResponse failed with error Incorrect OTP!!." ||
                  err.message === "Invalid session for the user."
                ) {
                  this.counter = 0;
                  this.Login.otp = "";
                  this.otpDigits = ["", "", "", "", "", ""];
                }
                this.SnackbarComponent = {
                  SnackbarVmodel: true,
                  SnackbarColor: "error",
                  SnackbarText: err.message,
                };
                this.OTPErrorMessage = err.message;
                this.isLoading = false;
              });
          } catch (error) {
            console.log("err", error);
          }
          break;
      }
    },

    startCounter() {
      this.interval = setInterval(() => {
        if (this.counter > 0) {
          this.counter--;
        } else {
          clearInterval(this.interval);
        }
      }, 1000);
    },

    handleOTPInput(index, event) {
      let value = event.target.value;

      // Only allow digits
      value = value.replace(/[^0-9]/g, "");

      // Update the digit
      this.otpDigits[index] = value;
      this.Login.otp = this.otpDigits.join("");

      // Auto-focus to next field if digit is entered
      if (value && index < 5) {
        this.$nextTick(() => {
          this.$refs[`otpInput${index + 1}`]?.[0]?.focus();
        });
      }
    },

    handleOTPKeydown(index, event) {
      // Handle backspace
      if (event.key === "Backspace") {
        if (!this.otpDigits[index] && index > 0) {
          // Move to previous field if current is empty
          this.$nextTick(() => {
            this.$refs[`otpInput${index - 1}`]?.[0]?.focus();
          });
        }
      }

      // Handle arrow keys
      if (event.key === "ArrowLeft" && index > 0) {
        this.$refs[`otpInput${index - 1}`]?.[0]?.focus();
      } else if (event.key === "ArrowRight" && index < 5) {
        this.$refs[`otpInput${index + 1}`]?.[0]?.focus();
      }
    },

    verifyOTP() {
      const otp = this.otpDigits.join("");
      if (otp.length !== 6) {
        this.SnackbarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "error",
          SnackbarText: "Please enter 6-digit OTP",
        };
        return;
      }
      this.SignInMethod("VERIFY_OTP");
    },

    ActivateMethod() {
      localStorage.setItem("user_email_id", this.Login.email_id);
      console.log(
        "localStorage after setting email: ",
        localStorage.getItem("user_email_id"),
      );
      setTimeout(async () => {
        localStorage.setItem("isLoggedIn", "yes");
        await this.GetCurrentUserInfoMethod(this.Login.email_id);
        this.$router.push("/polls");
      }, 1500);
    },

    resetForm() {
      this.Login.email_id = "";
      this.Login.otp = "";
      this.otpDigits = ["", "", "", "", "", ""];
      this.otpSent = false;
      this.counter = 0;
      clearInterval(this.interval);
      if (this.$refs.feedbackForm) {
        this.$refs.feedbackForm.reset();
      }
    },

    beforeDestroy() {
      clearInterval(this.interval);
    },
  },

  beforeUnmount() {
    clearInterval(this.interval);
  },
};
</script>

<style scoped>
.login-container {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
  min-height: 100vh;
  position: relative;
  overflow: hidden;
}

.login-card-wrapper {
  position: relative;
  z-index: 10;
  width: 420px;
}

.bg-light-blue {
  background-color: #f0f7ff;
  border-left: 4px solid #667eea;
}

.otp-input-container {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.otp-digit {
  flex: 1;
  max-width: 50px;
}

.otp-digit :deep(.v-input__control) {
  min-height: 48px;
}

.otp-digit :deep(input) {
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 2px;
}

.login-card {
  background: white !important;
  border-radius: 16px !important;
  box-shadow: 0 20px 60px rgba(102, 126, 234, 0.3),
    0 0 120px rgba(245, 87, 108, 0.2) !important;
}

.logo-circle {
  width: 60px;
  height: 60px;
  margin: 0 auto;
  border-radius: 12px;
  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
  display: flex;
  align-items: center;
  justify-content: center;
  /* box-shadow: 0 6px 15px rgba(102, 126, 234, 0.3); */
}

.decoration {
  position: absolute;
  border-radius: 50%;
  opacity: 0.1;
  z-index: 1;
}

.decoration-1 {
  width: 400px;
  height: 400px;
  background: white;
  top: -150px;
  right: -100px;
  z-index: 1;
  pointer-events: none;
}

.decoration-2 {
  width: 300px;
  height: 300px;
  background: white;
  bottom: -80px;
  left: -50px;
  z-index: 1;
  pointer-events: none;
}

.text-semibold {
  font-weight: 600;
}

.text-muted {
  color: #888888;
}

.text-sm {
  font-size: 0.9rem;
}

.text-gradient-primary {
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.btn-primary-gradient {
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
}

.btn-primary-gradient:hover {
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3) !important;
}
</style>
